import { combineReducers } from 'redux';

import notifications from './containers/Notifications/reducer';
import passwordAndAccess from './containers/PasswordAndAccess/reducer';
import numberManagement from './containers/NumberManagement/reducer';
import passportUpload from './containers/PassportUpload/reducer';

export default combineReducers({
  notifications,
  passwordAndAccess,
  numberManagement,
  passportUpload,
});
